import axios from 'axios';

const EDUCATOR_CLASSES_ENDPOINT = '/api/v1/educator/classes/';

const educatorClassesAPI = axios.create({
  baseURL: EDUCATOR_CLASSES_ENDPOINT,
});

educatorClassesAPI.interceptors.response.use(null, (error) => {
  throw error.response
    ? error.response.data
    : error;
});

export async function getUserClasses() {
  const response = await educatorClassesAPI.get();
  return response.data;
}

export async function getClassById(classId) {
  const response = await educatorClassesAPI.get(`${classId}/`);
  return response.data;
}

export async function createClass(data) {
  const response = await educatorClassesAPI.post(null, data);
  return response.data;
}

export async function editClass(classId, data) {
  const response = await educatorClassesAPI.put(`${classId}/`, data);
  return response.data;
}

export async function deleteClass(classId) {
  const response = await educatorClassesAPI.delete(`${classId}/`);
  return response;
}

export async function inviteStudents(classId, inviteList) {
  const response = await educatorClassesAPI.post(`${classId}/students/invite/`, inviteList);
  return response;
}

export async function resendInviteStudent(classId, email) {
  const response = await educatorClassesAPI.post(`${classId}/resend_invite/`, { email });
  return response;
}

export async function getClassStudents(classId) {
  const response = await educatorClassesAPI.get(`${classId}/students/`);
  return response.data;
}

export async function getClassAssignments(classId) {
  const response = await educatorClassesAPI.get(`${classId}/assignments/`);
  return response.data;
}

export async function createClassAssignment(classId, assignmentData) {
  const response = await educatorClassesAPI.post(`${classId}/assignments/`, assignmentData);
  return response.data;
}

export async function editClassAssignment(classId, assignmentId, assignmentData) {
  const response = await educatorClassesAPI.put(`${classId}/assignments/${assignmentId}/`, assignmentData);
  return response.data;
}
